"use client";

import "react-international-phone/style.css";

import {
  BaseTextFieldProps,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import React, { useEffect, useRef, useState } from "react";

import {
  CountryIso2,
  defaultCountries,
  FlagImage,
  parseCountry,
  usePhoneInput,
} from "react-international-phone";

import { useStore } from "@/hooks/use-store";

export interface MUIPhoneProps extends BaseTextFieldProps {
  value: string;
  onChange: (phone: string, country: string) => void;
}

export const PhoneInput: React.FC<MUIPhoneProps> = ({
  value,
  onChange,
  ...restProps
}: MUIPhoneProps) => {
  const { config } = useStore();
  const countries = defaultCountries;

  const containerRef = useRef<HTMLDivElement | null>(null);
  const [menuWidth, setMenuWidth] = useState<number>(0);

  const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
    defaultCountry: (config.country ?? "us").toLowerCase(),
    value,
    countries,
    onChange: (data) => onChange(data.phone, data.country.iso2),
  });

  useEffect(() => {
    if (containerRef.current) {
      const width = containerRef.current.getBoundingClientRect().width;
      setMenuWidth(width);
    }
  }, []);

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      <TextField
        fullWidth
        variant="outlined"
        value={inputValue}
        onChange={handlePhoneValueChange}
        type="tel"
        inputRef={inputRef}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start" style={{ marginRight: "2px", marginLeft: "-8px" }}>
                <Select
                  value={country.iso2}
                  onChange={(e) => setCountry(e.target.value as CountryIso2)}
                  renderValue={(valuePhone) => (
                    <FlagImage iso2={valuePhone} style={{ display: "flex" }} />
                  )}
                  MenuProps={{
                    // disablePortal: true,
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    transformOrigin: { vertical: "top", horizontal: "left" },
                    PaperProps: {
                      sx: {
                        maxWidth: `${menuWidth + 33}px`, // тут ширина формы
                        maxHeight: {
                          xs: "240px",
                          sm: "300px",
                        },
                        background: "var(--global-bg-color)",
                        overflow: "auto",
                        /* mt: {
                          xs: "-42px",
                          sm: "-42px",
                        }, */
                        mt: "5px",
                        ml: {
                          xs: "-7px",
                          sm: "-10px",
                        },
                      },
                    },
                  }}
                  sx={{
                    width: "max-content",
                    fieldset: {
                      display: "none",
                    },
                    '&.Mui-focused:has(div[aria-expanded="false"])': {
                      fieldset: {
                        display: "block",
                      },
                    },
                    ".MuiSelect-select": {
                      padding: "8px",
                      paddingRight: "24px !important",
                    },
                    svg: {
                      right: 0,
                    },
                  }}
                >
                  {countries.map((c) => {
                    const countryData = parseCountry(c);
                    return (
                      <MenuItem key={countryData.iso2} value={countryData.iso2}>
                        <FlagImage iso2={countryData.iso2} style={{ marginRight: "8px" }} />
                        <Typography color="white" marginRight="8px">
                          {countryData.name}
                        </Typography>
                        <Typography color="gray">+{countryData.dialCode}</Typography>
                      </MenuItem>
                    );
                  })}
                </Select>
              </InputAdornment>
            ),
          },
        }}
        {...restProps}
      />
    </div>
  );
};
